export default __webpack_public_path__ + "static/kiss-c638277eb329ac58ee249272a7feccee.jpg";